<template lang="pug">
#selecionar-car
    el-input.mb-3(
        id='idInputCar',
        :placeholder="$t('mensagens.laudos.digiteONumeroDoCar ')",
        prefix-icon='el-icon-search',
        v-model='carSelecionado',
        @change='buscarCar',
        @keyup.native.enter='buscarCar'
    )
    .conteudo
        div(v-if='carExibicao')
            h3.mb-3 {{ $t('mensagens.laudos.informacoesDoCar') }}
            p.mb-1 {{ $t('mensagens.laudos.areaHa') }}: {{ carExibicao.areaHa }}
            p.mb-1 {{ $t('mensagens.comuns.municipioUf') }}: {{ carExibicao.municipioUF }}
            p.mb-1 {{ $t('mensagens.laudos.situacao') }}: {{ carExibicao.situacao }}
    el-divider.custom-divider
    .botao.marginButton(slot='footer')
        BaseButton(type='outline', @click='cancelarModal') {{ $t('mensagens.comuns.cancelar') }}
        BaseButton(
            id='idAdicionar',
            type='primary',
            @click='enviarCarSelecionado',
            :disabled='!existeCarNaBaseLyra'
        )
            | {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
import UtilsService from '@/services/UtilsService';
import formatters from '@/utils/formatters';
import LaudosService from '@/services/LaudosService';
import TipoLaudo from '@/constants/TipoLaudo';
import StatusCar from '@/constants/StatusCar';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'SelecionarCar',
    components: {
        BaseButton
    },
    emits: ['cancelar-modal-avaliacao', 'getLaudos'],
    data() {
        return {
            carSelecionado: '',
            carExibicao: null,
            car: {},
            existeCarNaBaseLyra: false
        };
    },
    watch: {
        carSelecionado: function (value) {
            const CAR_SEM_FORMATACAO = 41;
            const CAR_COM_FORMATACAO = 43;
            if (!value) return;
            if (value.length === CAR_SEM_FORMATACAO || value.length === CAR_COM_FORMATACAO) {
                let mascara = '';
                value = value.replace(/[^\w\s]/gi, '');
                mascara = formatters.formatCar(value);
                this.carSelecionado = mascara;
                this.pesquisaValida = true;
            } else {
                this.pesquisaValida = false;
            }
        }
    },
    mounted() {

        window.addEventListener('keydown', function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
            }
        });
    },
    methods: {
        async buscarCar() {
            if (!this.pesquisaValida) {
                this.$notify.warning(
                    this.$t('mensagens.diagnosticoSocioambiental.erro.informacaoInvalida')
                );
                return;
            }
            if (this.carSelecionado === this.car.codigo) {
                return;
            }
            await UtilsService.getDadosCARSemGeometria(this.carSelecionado)
                .then(({data}) => {
                    if (data) {
                        this.carExibicao = {
                            areaHa: formatters.formatNumber(data.areaHa, 2),
                            municipioUF: `${data.nomeMunicipio}/${data.uf}`,
                            situacao: StatusCar[data.situacao]
                        };
                    }
                });
            try {
                await UtilsService.getDadosCAR({
                    codigosCar: this.carSelecionado
                }).then(({ data }) => {
                    data.resultados.forEach(({ geometry, properties }) => {
                        this.car = {
                            codigo: properties.codigo,
                            condicao: properties.situacao
                        };
                    });
                    this.existeCarNaBaseLyra = data.resultados.length > 0;
                });
            } catch {
                this.carExibicao = null;
                this.$notify.error({
                    message: this.$t('mensagens.laudos.erro.ocorreuUmErroAoBuscarCar')
                });
            }
            if (!this.existeCarNaBaseLyra) {
                this.carExibicao = null;
                this.$notify.warning({
                    message: this.$t('mensagens.laudos.erro.carNaoEncontradoNaBaseDoLyra')
                });
            }
            $('#idInputCar').trigger('blur');
        },
        enviarCarSelecionado() {
            let informacaoLaudos = [{
            tipoLaudoId: TipoLaudo.AVALIACAO_SOCIOAMBIENTAL,
            car: this.car
            }];
            LaudosService.cadastrarLaudos({ informacaoLaudos })
                .then(() => {
                    this.$notify.success({
                        message: this.$t('mensagens.laudos.solicitacaoRealizadaComSucesso')
                    });
                    this.cancelarModal();
                    this.$emit('getLaudos');
                })
                .catch(error => {
                    this.$notify.error({
                        message: error.message
                    });
                });
        },
        cancelarModal() {
            this.$emit('cancelar-modal-avaliacao');
        }
    }
};
</script>

<style lang="scss" scoped>
#selecionar-car {
    margin-top: -40px;

    .conteudo {
        min-height: 50vh;
        max-height: 50vh;
        overflow-y: auto;
        color: #00413c;
        margin: 1.5rem 0;
        display: flex;
        flex-wrap: wrap;
        overflow: auto;
        width: 100%;
    }
    .botao {
        margin-top: 0px;
        text-align: right;
        display: flex;
        justify-content: space-between;
    }

    .custom-divider {
        margin-bottom: 10px;
        margin-top: 0px;
    }
}
</style>
